import { useTheme } from '../../hooks/theme/useTheme';
import RenderProps from '../helpers/RenderProps';

export enum PageStructure {
  page = 'page',
  pageWrapper = 'pageWrapper',
  pageContent = 'pageContent',
  pageHeader = 'pageHeader',
  pageSubHeader = 'pageSubHeader',
  pageFooter = 'pageFooter',
  pageSidebar = 'pageSidebar',
}
export enum PageClasses {
  ThemePageSplit = 'ThemePageSplit',
  ThemePageModal = 'ThemePageModal',
  ThemePageList = 'ThemePageList',
  ThemePageLogin = 'ThemePageLogin',
  ThemePageCompactModal = 'ThemePageCompactModal',
  ThemePageError = 'ThemePageError',
  ThemePageLightbox = 'ThemePageLightbox',
  ThemePageStatic1 = 'ThemePageStatic1',
  ThemePageStatic2 = 'ThemePageStatic2',
}
export type Verify = Utils.VerifyExtends<Component.Page.Structure, typeof PageStructure>;
export default function Page(props: Component.Page.Import) {
  const extend = useTheme(PageStructure, props);
  return (
    <div {...extend(PageStructure.page, true)} id={props.id}>
      <div
        {...extend(PageStructure.pageWrapper)}
        children={
          <>
            {props.sidebar && <div {...extend(PageStructure.pageSidebar)} children={RenderProps(props, 'sidebar')} />}
            {props.header && <div {...extend(PageStructure.pageHeader)} children={RenderProps(props, 'header')} />}
            {props.subHeader && (
              <div {...extend(PageStructure.pageSubHeader)} children={RenderProps(props, 'subHeader')} />
            )}
            {Array.isArray(props.render) ? (
              props.render.map((c, i) => (
                <div key={i} {...extend(PageStructure.pageContent)} children={RenderProps({ ...props, render: c })} />
              ))
            ) : (
              <div {...extend(PageStructure.pageContent)} children={RenderProps(props)} />
            )}
            {props.footer && <div {...extend(PageStructure.pageFooter)} children={RenderProps(props, 'footer')} />}
            {props.extraFooter}
          </>
        }
      />
    </div>
  );
}
